
import { VLine } from "../area/VLine";
import { RoofShape } from "../roof/RoofShape";
import { SC_Input } from "../input/SC_Input";
import { Sol50OnRoof } from "./Sol50OnRoof";
import { AreaInformation } from "../area/AreaInformation";
import { AreaRect } from "../area/AreaRect";
import { Statics } from '../utilities/statics';
import { HGroup } from "../area/HGroup";
import { Sol50 } from "./Sol50";
import { Global } from "../utilities/global";
import { Rectangle } from "../area/Rectangle";
import { DrawVProfile } from './vProfile';
import * as _ from 'lodash';
import { SC_Beam } from '../roof/SC_Beam';

export function Purlin_VProfil_correctLength() {
    var nY: number;
    var nCnt: number;
    var nYDif: number;
    var nRoofHeight: number;
    var iBeamIndex: number;
    var nBeamPos1: number;
    var nBeamThickAdd: number = 5;
    var bExtended: boolean;
    var sRange: string;
    var nCantileverMax: number;
    var i: number;
    const nBeamDist1: number = SC_Input.nBeamDist2 + 100;
    // console.log(SC_Input.nBeamDist1, SC_Input.nBeamDist2)
    nRoofHeight = RoofShape.getCurrentRoofHeight() + 100;
    sRange = "f";
    nCantileverMax = Statics.oVerticalCantileverMax[sRange];
    const result: any = [];
    for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
        const vprofileTmp: VLine = new VLine(Sol50OnRoof.aVProfile[i]);
        //extend profile to next purlin if the limit of cantilever is exceeded
        //top
        bExtended = false;
        nY = vprofileTmp.t - nBeamDist1;
        if (nY < 0) {

            //first beam
        } else {
            iBeamIndex = parseInt("" + nY / SC_Input.nBeamDist) + 1;
            nBeamPos1 = (iBeamIndex * SC_Input.nBeamDist) + nBeamDist1;
            if (Math.abs(nBeamPos1 - vprofileTmp.t) > nCantileverMax) {
                vprofileTmp.t = (nBeamPos1 - SC_Input.nBeamDist) - nBeamThickAdd;
                bExtended = true;
            }
        }
        if (!bExtended) {
            //correct by cover trim and vertical overlap
            vprofileTmp.t = vprofileTmp.t - Sol50OnRoof.nVPOverLapTop;
        }
        //bottom
        bExtended = false;
        if (vprofileTmp.b > RoofShape.getCurrentRoofHeight() - SC_Input.nBeamDist1) {
            //last beam
        } else {
            nY = vprofileTmp.b - nBeamDist1;
            iBeamIndex = parseInt("" + nY / SC_Input.nBeamDist);
            nBeamPos1 = (iBeamIndex * SC_Input.nBeamDist) + nBeamDist1;
            if (Math.abs(vprofileTmp.b - nBeamPos1) > nCantileverMax) {
                vprofileTmp.b = (nBeamPos1 + SC_Input.nBeamDist) + nBeamThickAdd;
                bExtended = true;
            }
        }
        if (!bExtended) {
            //correct by cover trim and vertical overlap
            vprofileTmp.b += Sol50OnRoof.nVPOverLapBottom;
        }
        result.push(vprofileTmp);
    }
    Sol50OnRoof.aVProfile = result;
}

export function Purlin_VProfil_walkArea(aHLines: any[], area_info: AreaInformation) {

    var i: number;
    var j: number;
    var nX: number;
    var nXMax: number;
    var nSpanMax: number;
    var nCantileverMax: number;
    var nCurrent: number;
    var aTmp: any[];
    var vprofileTmp: VLine;
    var areaHLine: AreaRect;
    var nVSpace: number;
    aTmp = new Array();
    nSpanMax = Number.MAX_VALUE;
    //max row height
    if (area_info.hasPortrait) {
        nVSpace = SC_Input.nModHeight / 10;
    } else {
        nVSpace = SC_Input.nModWidth / 10;
    }
    // console.log(Statics.oSpanWidthMax[area_info.sRange][nVSpace.toString()])
    nSpanMax = Statics.oSpanWidthMax[area_info.sRange][nVSpace.toString()];
    nCantileverMax = nSpanMax * Statics.CANTILEVER_MAX_FACTOR;
    //find optimal start x
    var iFromStartCnt: number, iFromMiddleCnt: number, iFromEndCnt: number;
    iFromStartCnt = iFromMiddleCnt = iFromEndCnt = 0;
    for (i = 0; i < aHLines.length; i++) {
        areaHLine = <AreaRect>aHLines[i];
        var nTmp: number;
        //from start of cantilever
        nTmp = nSpanMax - ((areaHLine.x - area_info.left) % nSpanMax);
        if (nTmp <= nCantileverMax) {
            iFromStartCnt++;
        }
        //from middle of cantilever
        nTmp = nSpanMax - (((areaHLine.x + (nCantileverMax * 0.5)) - area_info.left) % nSpanMax);
        if (nTmp <= nCantileverMax) {
            iFromMiddleCnt++;
        }
        //from end of cantilever
        nTmp = nSpanMax - (((areaHLine.x + nCantileverMax) - area_info.left) % nSpanMax);
        if (nTmp <= nCantileverMax) {
            iFromEndCnt++;
        }
    }
    var iMax: number;
    var nCantileverFirst: number;
    if (iFromMiddleCnt >= iFromStartCnt) {
        iMax = iFromMiddleCnt;
        nCantileverFirst = nCantileverMax * 0.5;
    } else {
        iMax = iFromStartCnt;
        nCantileverFirst = 0;
    }
    if (iFromEndCnt >= iMax) {
        if (iFromEndCnt > iFromMiddleCnt) {
            nCantileverFirst = nCantileverMax;
        }
    }
    nX = area_info.left + nCantileverFirst;
    for (i = 0; i < aHLines.length; i++) {
        areaHLine = aHLines[i];
        nXMax = areaHLine.x + areaHLine.width;
        if (nX > areaHLine.x) {
            nTmp = areaHLine.x - (nX - nSpanMax);
        } else {
            nTmp = areaHLine.x - nX;
        }
        var nStart: number;
        nStart = nCurrent = areaHLine.x + (nSpanMax - (nTmp % nSpanMax));
        while (nCurrent < nXMax) {
            vprofileTmp = new VLine(null);
            vprofileTmp.t = areaHLine.y;
            vprofileTmp.b = areaHLine.y + areaHLine.height;
            vprofileTmp.x = nCurrent;
            aTmp.push(vprofileTmp);
            nCurrent += nSpanMax;
        }
        //left
        if (nStart - areaHLine.x > nCantileverMax) {
            vprofileTmp = new VLine(null);
            vprofileTmp.t = areaHLine.y;
            vprofileTmp.b = areaHLine.y + areaHLine.height;
            vprofileTmp.x = areaHLine.x + nCantileverMax * 0.5;
            aTmp.push(vprofileTmp);
        }
        //right
        if (nSpanMax - (nCurrent - nXMax) > nCantileverMax) {
            vprofileTmp = new VLine(null);
            vprofileTmp.t = areaHLine.y;
            vprofileTmp.b = areaHLine.y + areaHLine.height;
            vprofileTmp.x = nXMax - nCantileverMax * 0.5;
            aTmp.push(vprofileTmp);
        }
    }
    if (aTmp.length == 0) return;
    //sort by x
    // aTmp.sortOn("x", Array.NUMERIC);
    aTmp = _.sortBy(aTmp, 'x');
    var iLen: number = aTmp.length;
    var iCurrent: number = 0;
    var aCol: any[];
    while (iCurrent < iLen) {
        aCol = DrawVProfile.VProfile_getCol(aTmp, iLen, iCurrent);
        iCurrent += aCol.length;
        // aCol.sortOn("t", Array.NUMERIC);
        aCol = _.sortBy(aCol, 't');

        DrawVProfile.VProfile_optimize(aCol);
    }
}

export function Area_findNextRow(aAreaRects: any[], arearectTmp1: AreaRect, iStart: number, iLen: number): void {
    var nTop1: number, nBottom1: number;
    var nLeft1: number, nRight1: number;
    var nTop2: number, nBottom2: number;
    var nLeft2: number, nRight2: number;
    var arearectTmp2: AreaRect;
    var nYDif: number;
    var nVDist: number;
    var nHDist: number;
    var j: number;
    nTop1 = arearectTmp1.y;
    nBottom1 = arearectTmp1.y + arearectTmp1.height;
    nLeft1 = arearectTmp1.x;
    nRight1 = arearectTmp1.x + arearectTmp1.width;
    nVDist = Sol50.nVertikalAbstand + Global.nModAbstTol;
    nHDist = Sol50.nHorizontalAbstand + Global.nModAbstTol;
    for (; iStart < iLen; iStart++) {
        arearectTmp2 = aAreaRects[iStart];
        nTop2 = arearectTmp2.y;
        nBottom2 = arearectTmp2.y + arearectTmp2.height;
        nLeft2 = arearectTmp2.x;
        nRight2 = arearectTmp2.x + arearectTmp2.width;
        nYDif = nTop2 - nBottom1;
        if (nYDif > nVDist) {
            break;
        } else if (nYDif > 0) {
            if (nLeft2 < nRight1 + nHDist && nRight2 + nHDist > nLeft1) {
                if (arearectTmp2.aGroup != null) {
                    if (arearectTmp1.aGroup != arearectTmp2.aGroup) {
                        //swap
                        Area_swapGroup(arearectTmp1.aGroup, arearectTmp2.aGroup);
                    }
                    continue;
                } else {
                    arearectTmp1.aGroup.push(arearectTmp2);
                    arearectTmp2.aGroup = arearectTmp1.aGroup;
                }
                j = iStart + 1;
                if (j < iLen) {
                    Area_findNextRow(aAreaRects, arearectTmp2, j, iLen);
                }
            }
        }
    }
}

export function Area_determine(): any[] {
    var hgroupTmp: HGroup;
    var i: number, j: number;
    var iLen: number;
    var aAreaRects: any[];
    var arearectTmp: AreaRect;
    var aGroup: any[];
    var aGroupList: any[];
    iLen = Global.hgroups.length;
    aGroupList = new Array();
    if (iLen == 0) return aGroupList;
    //copy
    aAreaRects = new Array();
    for (i = 0; i < iLen; i++) {
        hgroupTmp = new HGroup(Global.hgroups[i]);
        arearectTmp = new AreaRect();
        arearectTmp.x = hgroupTmp.x;
        arearectTmp.y = hgroupTmp.y;
        arearectTmp.width = hgroupTmp.width;
        arearectTmp.height = hgroupTmp.height;
        aAreaRects.push(arearectTmp);
    }
    //sort by y
    aAreaRects = _.sortBy(aAreaRects, 'y');
    for (i = 0; i < iLen; i++) {
        arearectTmp = aAreaRects[i];
        if (arearectTmp.aGroup != null) {
            continue;
        }
        aGroup = new Array();
        aGroup.push(arearectTmp);
        arearectTmp.aGroup = aGroup;
        j = i + 1;
        if (j < iLen) {
            Area_findNextRow(aAreaRects, arearectTmp, j, iLen);
        }
        if (aGroup.length > 0) {
            aGroupList.push(aGroup);
        }
    }
    return aGroupList;
}

export function Area_collectInformation(aGroupList: any[]): any[] {
    var rect: Rectangle;
    var sRange: string;
    var i: number;
    var j: number;
    var aGroupTmp: any[];
    var areaHLine: AreaRect;
    var aAreaInfo: any[];
    var ret: AreaInformation;
    var info: AreaInformation;
    var nLeft: number;
    var nRight: number;
    // aGroupList = Sol50OnRoof.Area_determine();
    //rectangle buffer
    rect = new Rectangle();
    aAreaInfo = new Array();
    for (i = 0; i < aGroupList.length; i++) {
        nLeft = Number.MAX_VALUE;
        nRight = Number.MIN_VALUE;
        aGroupTmp = aGroupList[i];
        info = new AreaInformation();
        info.sRange = "h";
        info.hasPortrait = false;
        for (j = 0; j < aGroupTmp.length; j++) {
            areaHLine = <AreaRect>aGroupTmp[j];
            rect.left = areaHLine.x;
            rect.top = areaHLine.y;
            rect.height = areaHLine.height;
            rect.width = areaHLine.width;
            sRange = RoofShape.getRangeByRect(rect);
            if (nLeft > areaHLine.x) {
                nLeft = areaHLine.x;
            }
            if (nRight < areaHLine.x + areaHLine.width) {
                nRight = areaHLine.x + areaHLine.width;
            }
            if (info.sRange.charCodeAt(0) > sRange.charCodeAt(0)) {
                info.sRange = sRange;
            }
            //check for portrait panel alignment
            if (areaHLine.height > SC_Input.nModWidth) {
                info.hasPortrait = true;
            }
        }
        info.left = nLeft;
        info.right = nRight;
        aAreaInfo.push(info);
    }
    return aAreaInfo;
}

export function Area_swapGroup(aGroupSrc: any[], aGroupDst: any[]): void {
    aGroupSrc.forEach((arearectTmp) => {
        arearectTmp.aGroup = aGroupDst;
        aGroupDst.push(arearectTmp);
    });
    // for each(var arearectTmp: AreaRect in aGroupSrc) {

    // }
    aGroupSrc.splice(0);
}

export function Purlin_VProfile_isOptimal(): boolean {
    var i: number;
    var bRet: boolean;
    var vprofileTmp: VLine;
    var nYLast: number = 1;//TFE
    if (SC_Input.iBeamType == SC_Beam.PURLIN) {
        // Sol50OnRoof.Purlin_VProfile_find();
        DrawVProfile.Purlin_VProfile_find();
    } else {
        return true;
    }
    bRet = true;
    for (i = 0; i < Sol50OnRoof.aVProfile.length; i++) {
        vprofileTmp = new VLine(Sol50OnRoof.aVProfile[i]);
        if (i > 0) {
            if (nYLast != vprofileTmp.t) {
                bRet = false;
                break;
            }
        }
        nYLast = vprofileTmp.t;
    }
    return bRet;
}
